// extracted by mini-css-extract-plugin
export default {"container":"ThemeDemo_container__2d+xt","light":"ThemeDemo_light__GMP7Q","dark":"ThemeDemo_dark__ZPUTA"};